<template>
  <div class="signUp isSended">
    <p class="title">Check your email!</p>
    Dear {{ firstName }} {{ lastName }}, thank you for signing up! We have sent a confirmation email to {{user}}
    <br/>
    <br/>
    Once your email is verified, you can sign in and start using our platform.
    <div>
      <div class="resend">
        <p>Didn’t receive the email? <span @click="submit">Resend</span></p>
        <div v-if="loading" class="loader">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 42 42" fill="none">
            <g clip-path="url(#clip0_719_13172)">
              <path d="M21 10.5V5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10.5 21H5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                d="M13.5623 13.5625L9.7998 9.79999" stroke="#09373D" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_719_13172">
                <rect width="42" height="42" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div class="message" v-if="globalError || isSended">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <path stroke="#6F8789" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21c4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9Zm0-10v5"/>
          <path stroke="#6F8789" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.9502 8h.1v.1h-.1V8Z"/>
        </svg>
        <div>
          <p v-if="globalError">{{globalError}}</p>
          <p v-if="isSended">We sent the letter again</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resendEmail } from '@/api'
export default {
  data: () => ({
    globalError: false,
    isSended: false,
    loading: false,
  }),
  props: {
    user: {
      type: String,
      required: true,
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
  },
  methods: {
    async submit () {
      this.loading = true
      try {
        await resendEmail(this.user)
        this.isSended = true
        this.loading = false
      } catch (e) {
        this.globalError = e.message
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.isSended {
  display: grid;
  gap: 32px;
  font-size: 16px;
  p {
    margin: 0 !important;
  }
  .resend {
    display: flex;
    align-items: center;
    gap: 16px;
    color: var(--secondary);
    font-size: 14px;
    span {
      color: var(--text_color);
      border-bottom: 1px solid;
      cursor: pointer;
    }
  }
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 40px);
    svg {
      animation: spin 1.5s linear infinite;
    }
  }
  .message {
    border-radius: 8px;
    border: 1px solid var(--Dividers, #E0E9EA);
    background: var(--Surface, #FAFBFB);
    padding: 12px;
    display: flex;
    gap: 16px;
    font-size: 14px;
    margin-top: 24px;
    color: var(--Text-Text_Secondary);
  }
}
@media (max-width: 480px) {
    .isSended {
      margin: 92px 16px 16px !important;
      padding: 24px !important;
      .title {
        font-size: 20px !important;
      }
    }
}
</style>
